<div class="row" *ngIf="form">
  <div class="col-12 d-none">
    Is Export Customer: {{ checkout.extra.isExportCustomer }}<br />
    Is Phone Mandatory: {{ isPhoneMandatory }}<br />
  </div>
  <div class="col-12 col-md-6">
    <fieldset [disabled]="!enableEditDeliveryAddress">
      <div class="form-group" *ngIf="deliveryLocations.length > 0">
        <label for="deliveryLocation" class="control-label" translate>DELIVERY_LOCATION</label>
        <select name="deliveryLocation" id="deliveryLocation" class="form-control form-select"
          [(ngModel)]="deliveryLocationId">
          <option [value]="option.id" *ngFor="let option of deliveryLocations">
            {{ option.name }}
          </option>
        </select>
      </div>
      <div class="form-group" [formGroup]="form">
        <label for="ordlevadr1" class="control-label" translate>OH_ORDLEVADR1</label>
        <input class="form-control" type="text" name="ordlevadr1" id="ordlevadr1" [formControlName]="'ordlevadr1'" />
        <div *ngIf="form.get('ordlevadr1').invalid && (form.get('ordlevadr1').dirty || form.get('ordlevadr1').touched)"
          class="alert alert-danger">
          <span translate>FORM_ERROR_REQUIRED</span>
        </div>
      </div>
    </fieldset>
    <div class="form-group" [formGroup]="formOh">
      <!-- INPUT FOR THE NON MANDATORY CASE-->
      <label for="q_oh_teleavisering" class="control-label" translate>OH_Q_OH_TELEAVISERING</label>
      <input class="form-control" type="tel" name="q_oh_teleavisering" id="q_oh_teleavisering"
        formControlName="q_oh_teleavisering" />
      <lib-forms-message-error [controller]="formOh.get('q_oh_teleavisering')"></lib-forms-message-error>
    </div>
    <fieldset [disabled]="!enableEditDeliveryAddress">
      <div class="form-group" [formGroup]="form">
        <label for="ordlevadr2" class="control-label" translate>OH_ORDLEVADR2</label>
        <input class="form-control" type="text" name="ordlevadr2" id="ordlevadr2" [formControlName]="'ordlevadr2'" />
      </div>
      <div class="form-group" [formGroup]="form">
        <label for="ordlevadr3" class="control-label" translate>OH_ORDLEVADR3</label>
        <input class="form-control" type="text" name="ordlevadr3" id="ordlevadr3" [formControlName]="'ordlevadr3'" />
        <lib-forms-message-error [controller]="form.get('ordlevadr3')"></lib-forms-message-error>
      </div>
      <div class="form-group" [formGroup]="form">
        <label for="ftgpostnr" class="control-label" translate>OH_FTGPOSTNR</label>
        <input class="form-control" type="text" name="ftgpostnr" id="ftgpostnr" [formControlName]="'ftgpostnr'" />
        <lib-forms-message-error [controller]="form.get('ftgpostnr')"></lib-forms-message-error>
      </div>
      <div class="form-group" [formGroup]="form">
        <label for="ordlevadr4" class="control-label" translate>OH_ORDLEVADR4</label>
        <input class="form-control" type="text" name="ordlevadr4" id="ordlevadr4" [formControlName]="'ordlevadr4'" />
        <lib-forms-message-error [controller]="form.get('ordlevadr4')"></lib-forms-message-error>
      </div>
      <div [formGroup]="form">
        <lib-meta-select-input formControlName="ordlevadrlandskod" table="xr" metaId="landskod" metaDisplay="land">
        </lib-meta-select-input>
        <lib-forms-message-error [controller]="form.get('ordlevadrlandskod')"></lib-forms-message-error>
      </div>
    </fieldset>
    <div class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" id="editDeliveryLocation" name="editDeliveryLocation"
        (change)="toggleEditDeliveryAddress()" [disabled]="blockEditAddress? true : undefined" />
      <label class="custom-control-label" for="editDeliveryLocation" translate>TYLO_EDIT_DELIVERY_ADDRESS</label>
    </div>
  </div>
  <div class="col-12 col-md-6">
    <div class="form-group" [formGroup]="formOh">
      <label for="ta_mailnotified" class="control-label" translate>OH_TA_MAILNOTIFIED</label>
      <input class="form-control" type="text" name="ta_mailnotified" id="ta_mailnotified"
        formControlName="ta_mailnotified" />
      <lib-forms-message-error [controller]="formOh.get('ta_mailnotified')"></lib-forms-message-error>
    </div>
    <lib-confirmation-emails (emailsUpdated)="checkout.extra.confirmationEmails = $event"></lib-confirmation-emails>
    <div class="form-group" [formGroup]="formOh">
      <!-- INPUT FOR THE NON MANDATORY CASE-->
      <label for="q_oh_teleavisering" class="control-label" translate>OH_Q_OH_TELEAVISERING</label>
      <input class="form-control" type="tel" name="q_oh_teleavisering" id="q_oh_teleavisering"
        formControlName="q_oh_teleavisering" />
      <lib-forms-message-error [controller]="formOh.get('q_oh_teleavisering')"></lib-forms-message-error>
    </div>
    <div class="form-group" [formGroup]="formOh">
      <label for="kundbestnr" class="control-label"><span translate>OH_KUNDBESTNR</span>*</label>
      <input class="form-control" type="text" name="kundbestnr" id="kundbestnr" formControlName="kundbestnr" />
      <div
        *ngIf="formOh.get('kundbestnr').invalid && (formOh.get('kundbestnr').dirty || formOh.get('kundbestnr').touched)"
        class="alert alert-danger">
        <span translate>FORM_ERROR_REQUIRED</span>
      </div>
    </div>
    <div class="form-group" [formGroup]="formOh">
      <label for="kundbestnr" class="control-label" translate>OH_GODSMARKE1</label>
      <input class="form-control" type="text" name="godsmarke1" id="godsmarke1" formControlName="godsmarke1" />
    </div>
    <div class="form-group" [formGroup]="formOh" *ngIf="!isExportCustomer">
      <label for="kundref2" class="control-label" translate>OH_KUNDREF2</label>
      <input class="form-control" type="text" name="kundref2" id="kundref2" formControlName="kundref2" />
      <!--
      <div *ngIf="formOh.get('kundref2').invalid && (formOh.get('kundref2').dirty || formOh.get('kundref2').touched)"
        class="alert alert-danger">
        <span translate>FORM_ERROR_REQUIRED</span>
      </div>
      -->
    </div>
    <div class="form-group" [formGroup]="formOh">
      <label for="edit" class="control-label w-100" translate>OH_EDITEXT</label>
      <textarea id="edit" name="edit" class="form-control w-100" formControlName="edit" rows="9" cols="50"></textarea>
    </div>
  </div>
</div>
